import api from '@/api/jai.js';
import _ from 'lodash';
import showSwal from "@/mixins/showSwal.js";

export default {
	namespaced: true,
	state: function() {
		return {
			waiting: false,
			widgets: [],
			currentWidget: null,
			stack: [],
			waitingAnalisi: false,	
			waitingSave: false,
		}
	},
	mutations: {
		setWidget: function(state, data) {
			state.currentWidget = data;
			if(state.currentWidget  == null) {
				state.stack = [];
			}
		},
		setErrorMessage: function(state, text) {
			showSwal.methods.showSwal({
				type:"error",
				message: text,
				icon: 'error'
			});
		},
		setSuccessMessage: function(state, text) {
			showSwal.methods.showSwal({
				type:"success",
				message: text,
				icon: 'success'
			});
		},
		addStack: function(state, data) {
			state.stack.unshift(data);
		},
		setWaiting: function(state, data) {
			state.waiting = data;
		},
		setWaitingAnalisi: function(state, data) {
			state.waitingAnalisi = data;
		},
		setWaitingSave: function(state, data) {
			state.waitingSave = data;
		},
	},
	actions: {
		askQuestion: async function({state, commit, getters}, args) {
			commit('setWaiting', true);
			commit('addStack', args);
			var data = await api.askQuestion(getters.stack);
			console.log(data);
			if(_.has(data, 'error')) {
				state.stack.shift();
				commit('setErrorMessage', data.error);
				if(_.has(data, 'widget')) {
					commit('setWidget', data.widget);
				}
			} else {
				if(_.has(data.response, 'query')) {
					state.stack.unshift(data.response.query);
				}
				commit('setWidget', data);
			}
			commit('setWaiting', false);
		},

	},
	getters: {
		currentWidget: function(state) {
			return state.currentWidget;
		},
		stack: function(state) {
			return state.stack;
		},
		waiting: function(state) {
			return state.waiting;
		},
		waitingAnalisi: function(state) {
			return state.waitingAnalisi;
		},
		waitingSave: function(state) {
			return state.waitingSave;
		},
	}
}